import {Selectors} from "@core/store/selectors";
import {getUserText} from "@util";
import {useSelector} from "react-redux";

const useUsers = () => {
  const users = useSelector(Selectors.users) ?? [];

  const getUserFullname = (userId: string | undefined) => {
    const u = users.find(u => u.id === userId);
    return u ? getUserText(u) : "-";
  };

  return {getUserFullname};
};

export {useUsers};
